import React from 'react'

import { FormattedMessage } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'

import { ConnectedTrackedRoute } from '@components/UI/TrackedRoute'
import { useCampaignContext } from '@context/Campaign'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { selectHasPublishedUrl, selectPublishedUrl } from '@store/submissions'
import Theme from '@theme'
import { Button, Container, Icon, Link as TribeLink } from '@tribegroup'

interface IProps {
  submissionId: number
}

const SubmissionCardPublishedURL: React.FC<IProps> = ({ submissionId }) => {
  const { publishedUrl, hasPublishedUrl } = useSelector((state: IApplicationState) => ({
    publishedUrl: selectPublishedUrl(state, submissionId),
    hasPublishedUrl: selectHasPublishedUrl(state, submissionId),
  }), shallowEqual)

  const { campaign } = useCampaignContext()
  const campaignId = campaign?.id

  if (!hasPublishedUrl) {
    return null
  }

  return (
    <Container absolute bottomPosition={0.75} rightPosition={1}>
      <ConnectedTrackedRoute
        inline
        eventName={EventTrackingNames.ViewPublishedSubmission}
        campaignId={campaignId}
        submissionId={submissionId}
        additionalProperties={{ submission_id: submissionId }}
        targetLink
      >
        <TribeLink
          href={publishedUrl!}
          target="_blank"
          rel="noopener noreferrer"
          color={Theme.primaryColor}
          size={0.875}
        >
          <Button centered scheme="primary" small>
            <FormattedMessage
              id="submission.fullView.viewPublishedSubmission.withArrow"
              defaultMessage="View Published Submission >"
            />
            <Icon glyph="external-link" color={Theme.whiteColor} size={1} />
          </Button>
        </TribeLink>
      </ConnectedTrackedRoute>
    </Container>
  )
}

export default SubmissionCardPublishedURL
